import fix5213 from './5213';
export default (grapesjs) => {
  fix5213(grapesjs);
}